<template>
    <v-app>
        <v-container fluid>
            <project-budget-setup :dialog="dialog" :data="data" @update:dialog="dialog = $event" @save-budget="saveBudgetHandler" />

            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Project Budget
                                List</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                    <v-col md="4" cols="12">
                                        <v-text-field v-model="search" append-inner-icon="mdi-magnify" label="Search"
                                            single-line hide-details density="compact" variant="outlined"
                                            bg-color="grey-lighten-4" class="pl-2" clearable></v-text-field>
                                    </v-col>

                                    <v-col md="5" cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success"
                                                    @click="exportToCSV">CSV</v-btn>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary"
                                                    @click="exportToExcel">EXCEL</v-btn>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red"
                                                    @click="exportToPDF">PDF</v-btn>
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                    <v-col md="3" cols="12">
                                        <div class="text-right pr-2">
                                            <v-btn v-if="$insertAccess($route.path)"
                                                @click="openAddBudget" color="primary" variant="tonal"
                                                prepend-icon="mdi mdi-plus" rounded="xl">
                                                Add Budget
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-data-table :headers="headers" :items="getProjectBudgetList" :loading="loading"
                                    v-model:items-per-page="itemsPerPage" :search="search" :hover="true"
                                    density="compact">

                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>

                                    <template v-slot:item.project_total_budget="{ item }">
                                        {{ formatCurrency(item.project_total_budget) }}
                                    </template>

                                    <template v-slot:item.budget_status="{ item }">
                                        <v-chip v-if="item.budget_status == 'approved'" color="success" size="small"
                                            class="text-capitalize">Approved</v-chip>
                                        <v-chip v-else-if="item.budget_status == 'draft'" color="warning" size="small"
                                            class="text-capitalize">Draft</v-chip>
                                        <v-chip v-else color="grey" size="small"
                                            class="text-capitalize">{{ item.budget_status || 'N/A' }}</v-chip>
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                        <v-chip v-if="item.status == 1" color="success" size="small"
                                            class="text-capitalize">Active</v-chip>
                                        <v-chip v-else color="red" size="small"
                                            class="text-capitalize">Inactive</v-chip>
                                    </template>

                                    <template v-slot:item.approved_date="{ item }">
                                        {{ formatDate(item.approved_date) }}
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-icon class="me-2 edit-button" color="primary" @click="editItem(item)"
                                            v-if="$updateAccess($route.path)">
                                            mdi mdi-pencil-outline
                                        </v-icon>
                                        <v-icon class="me-2 edit-button" color="red" @click="deleteItem(item)"
                                            v-if="$updateAccess($route.path)">
                                            mdi mdi-delete-outline
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import Axios from 'axios';
import { toast } from "vue3-toastify";
import ProjectBudgetSetup from "@/components/module/project/budgetManagement/projectBudget.vue";

export default {
    components: {
        ProjectBudgetSetup,
    },
    data: () => ({
        itemsPerPage: 50,
        panel: [0],
        loading: false,
        search: "",
        dialog: false,
        data: {},
        headers: [
            { title: "#SL", align: "center", key: "index", width: "7%", sortable: true },
            { title: "Project Budget ID", key: "id", align: "left", sortable: true },
            { title: "Project Name", key: "project_name", align: "left", sortable: true },
            { title: "Project Code", key: "project_code", align: "left", sortable: true },
            { title: "Project Total Budget", key: "project_total_budget", align: "right", sortable: true },
            { title: "Budget Status", align: "center", key: "budget_status", sortable: true },
            { title: "Status", align: "center", key: "status", sortable: true },
            { title: "Approved By", key: "approved_by", align: "left", sortable: true },
            { title: "Approved Date", key: "approved_date", align: "left", sortable: true },
            { title: "Actions", align: "center", key: "actions", sortable: true }
        ],
    }),
    watch: {},
    created() {
        if (this.$store.getters.getProjectBudgetList.length == 0) {
            this.loading = true;
            this.$store.dispatch('getProjectBudgetList').then((response) => {
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        }
    },
    computed: {
    getProjectBudgetList() {
        return this.$store.getters.getProjectBudgetList.map(item => ({
            ...item,
            project_name: item.project?.project_title || item.project?.name || '', // ✅ Flatten project name
            project_code: item.project?.code || '', // ✅ Flatten project code
        }));
    },
},
    methods: {
        openAddBudget() {
            this.data = {
                project_id: "",
                project_code: "",
                project_total_budget: "",
                budget_status: "draft",
                status: "1",
                budget_id: null,
            };
            this.dialog = true;
        },
        saveBudgetHandler(budget) {
            // Handle save callback if needed
        },
        editItem(item) {
            this.data = { ...item, id: item.id };
            this.dialog = true;
        },
       
        formatCurrency(amount) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            }).format(amount || 0);
        },
        formatDate(date) {
            if (!date) return '';
            return new Date(date).toLocaleDateString();
        },
        exportToPDF() {
            let serialNumber = 1;
            const columns = ['#SL', 'Project Budget ID', 'Project Name', 'Project Code', 'Project Total Budget', 'Budget Status', 'Status', 'Approved By', 'Approved Date'];
            const rows = this.getProjectBudgetList.map(item => [
                serialNumber++,
                item.id,
                item.project_name,
                item.project_code,
                this.formatCurrency(item.project_total_budget),
                item.budget_status == 'approved' ? 'Approved' : item.budget_status == 'draft' ? 'Draft' : (item.budget_status || 'N/A'),
                item.status == 1 ? 'Active' : 'Inactive',
                item.approved_by || '',
                this.formatDate(item.approved_date)
            ]);
            this.$exportTableToPDF(columns, rows, 'Project Budget List', 'project_budget_list_' + this.$fileDate())
        },
        exportToExcel() {
            var data = [['#SL', 'Project Budget ID', 'Project Name', 'Project Code', 'Project Total Budget', 'Budget Status', 'Status', 'Approved By', 'Approved Date']];
            var serialNumber = 1;
            this.getProjectBudgetList.forEach(item => {
                data.push([
                    serialNumber++,
                    item.id,
                    item.project_name,
                    item.project_code,
                    item.project_total_budget,
                    item.budget_status == 'approved' ? 'Approved' : item.budget_status == 'draft' ? 'Draft' : (item.budget_status || 'N/A'),
                    item.status == 1 ? 'Active' : 'Inactive',
                    item.approved_by || '',
                    this.formatDate(item.approved_date)
                ]);
            });
            this.$exportTableToExcel(data, 'project_budget_list_' + this.$fileDate());
        },
        exportToCSV() {
            var data = [['#SL', 'Project Budget ID', 'Project Name', 'Project Code', 'Project Total Budget', 'Budget Status', 'Status', 'Approved By', 'Approved Date']];
            var serialNumber = 1;
            this.getProjectBudgetList.forEach(item => {
                data.push([
                    serialNumber++,
                    item.id,
                    item.project_name,
                    item.project_code,
                    item.project_total_budget,
                    item.budget_status == 'approved' ? 'Approved' : item.budget_status == 'draft' ? 'Draft' : (item.budget_status || 'N/A'),
                    item.status == 1 ? 'Active' : 'Inactive',
                    item.approved_by || '',
                    this.formatDate(item.approved_date)
                ]);
            });
            this.$exportTableToCSV(data, 'project_budget_list_' + this.$fileDate());
        },
    },
    mounted() {}
}
</script>